angular.module('harriApp').factory('ColorsHelper', function () {
    var HelperData = {};

    /**
     * return if the color is light or bright
     * @param r
     * @param g
     * @param b
     * @returns {boolean}
     */
    var colourIsLight = function (r, g, b) {
        // Counting the perceptive luminance
        // human eye favors green color...
        var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return (a < 0.5);
    };


    /**
     * Check if background is light
     * @param color
     */
    HelperData.isLight = function (color) {
        if (color) {
            var rgbColor = Utils.hexToRGB(color);
            return colourIsLight(rgbColor.r, rgbColor.g, rgbColor.b);
        }
        else {
            console.error("color is undefined")
        }
    };

    /**
     * Get Random Color
     * @returns {string}
     */
    HelperData.getRandomColor = function () {
        var letters = '0123456789ABCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };


    var usedColorsMemo = {};
    HelperData.getPredefineColorFromTag = function (tags, key) {

        var userColors = _.map(tags, function (tag) {
            return tag.color_hash;
        });
        var colors = ['#842113', '#97040c', '#02F29E', '#b25f1a',
            '#be8f1f', '#174f5b', '#452843', '#1959c9',
            '#2595CB', '#508693', '#125592', '#754E3E', '#B787A9',
            '#C945F9', '#05E80D', '#3a7524', '#731d47',
            '#493941', '#9F8C43', '#352073'];

        var availableColors = _.difference(colors, userColors);

        if (!usedColorsMemo[key]) {
            usedColorsMemo[key] = [];
        }

        availableColors = _.difference(availableColors, usedColorsMemo[key]);


        usedColorsMemo[key].push(availableColors[0]);

        if (availableColors[0]) {
            return availableColors[0];
        }
        else {
            return HelperData.getRandomColor();
        }
    };


    return HelperData;
});